import { useEffect, useState } from 'react';
import { Box, Card, Tab, Tabs } from '@mui/material';
import TabPanel from './TabPanel';
import LearnMoreCreator from '../LearnMoreCreator/LearnMoreCreator';
import SurveyCreator from '../SurveyCreator/SurveyCreator';
import { AdminToolSkeleton } from 'react-components/admin-dashboard/components/AdminToolSkeleton';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import JsonPreview from './JSONPreview';
import LivePreview from './LivePreview';
import { getSurveyRecords } from 'redux/slices/surveyCreatorSlice';
import { getLearnMoreRecords } from 'redux/slices/learnMoreCreatorSlice';
import { useAppDispatch } from 'redux/store-hooks';

const MultipanelContainer = () => {
  const dispatch = useAppDispatch();
  const [leftTabValue, setLeftTabValue] = useState<number>(0);
  const [rightTabValue, setRightTabValue] = useState<number>(0);

  useEffect(() => {
    dispatch(getLearnMoreRecords({}));
    dispatch(getSurveyRecords({}));
  }, [dispatch]);

  return (
    <AdminToolSkeleton
      title="Survey Creator"
      toolDescription="Create and edit survey and learn more content here."
    >
      <DndProvider backend={HTML5Backend}>
        <Box
          sx={{
            display: 'flex',
            gap: '16px',
            padding: '16px',
            width: '100%',
            height: '100%',
            overflow: 'hidden',
            boxSizing: 'border-box',
            backgroundColor: 'background.paper',
          }}
        >
          {/* Editor panel */}
          <Box
            sx={{
              flex: '1 1 60%',
              display: 'flex',
              height: '100%',
              minWidth: '400px',
              overflow: 'hidden',
            }}
          >
            <Card
              sx={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <Box sx={{ borderBottom: '8px', borderColor: 'divider' }}>
                <Tabs
                  value={leftTabValue}
                  onChange={(_, newValue) => setLeftTabValue(newValue)}
                  sx={{
                    border: '1px solid rgba(220, 228, 232, 0.5)',
                  }}
                >
                  <Tab label="Survey Creator" />
                  <Tab label="Learn More Creator" />
                </Tabs>
              </Box>
              <Box sx={{ flex: '1 1 auto', overflow: 'hidden' }}>
                <TabPanel index={0} value={leftTabValue}>
                  <SurveyCreator />
                </TabPanel>
                <TabPanel index={1} value={leftTabValue}>
                  <LearnMoreCreator />
                </TabPanel>
              </Box>
            </Card>
          </Box>
          {/* Preview panel */}
          <Box
            sx={{
              flex: '1 1 40%',
              height: '100%',
              display: 'flex',
              overflow: 'hidden',
            }}
          >
            <Card
              sx={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <Box sx={{ borderBottom: '8px', borderColor: 'divider' }}>
                <Tabs
                  value={rightTabValue}
                  onChange={(_, newValue) => setRightTabValue(newValue)}
                  sx={{
                    border: '1px solid rgba(220, 228, 232, 0.5)',
                  }}
                >
                  <Tab label="Preview" />
                  <Tab label="JSON Preview" />
                </Tabs>
              </Box>
              <Box sx={{ flex: '1 1 auto', overflow: 'hidden' }}>
                {/*
                 * LeftTabValue: 0 - 'survey'; 1 - 'learnMore'
                 * RightTabValue: 0 - 'Live Preview'; 1 - 'JSON Preview'
                 */}
                <TabPanel index={0} value={rightTabValue}>
                  <LivePreview
                    previewType={leftTabValue === 0 ? 'survey' : 'learnMore'}
                  />
                </TabPanel>
                <TabPanel index={1} value={rightTabValue}>
                  <JsonPreview
                    previewType={leftTabValue === 0 ? 'survey' : 'learnMore'}
                  />
                </TabPanel>
              </Box>
            </Card>
          </Box>
        </Box>
      </DndProvider>
    </AdminToolSkeleton>
  );
};

export default MultipanelContainer;
